/*
  Displays all billing plans (ie. rate schedules) available in a rate schedule collection
  based on the supplied rate schedule id parameter.
  
  Encapsulates all logic to render the additional charges modal as well.
  Can handle displaying multiple rate schedule cards.

  This is used in the signup view to let the user select a rate schedule.
*/

import {RateScheduleCard} from 'admin/accounting/rate_schedule_cards'

export class SignupSummaryRateSchedules extends HTMLElement {
  constructor(rate_schedule_id) {
    super(rate_schedule_id);
    this.rate_schedule_id = parseInt(rate_schedule_id)
  }

  getSelectedRateScheduleId(){
    return this.rate_schedule_id
  }
  
  async loadData(){
    let url = `/admin/rate_schedules/${this.rate_schedule_id}/group_rate_schedules`
    let res = await fetch(url);
    this.data = await res.json();
    // console.log('SignupSummaryRateSchedules data: ',this.data)
  }
  
  async connectedCallback() {
    await this.loadData()

    this.innerHTML = `
      <select class="form-control" id="signup_plan_select"></select>

      <div class="row">
        <template id="additional_charges_template">      
          <div class="content">
            <table class="pricing-table">
              <colgroup>
                <col class="col-headers" />
                <col class="col-data" />
              </colgroup>
              <thead>
                <tr>
                  <td class="info">
                    <p class="title"></p>
                  </td>
                  <th scope="col">
                    <p class="tier">
                      Starting at <span class="price"></span>
                    </p>
                    <p>
                      Monthly fee plus<br />additional usage.
                    </p>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </template>

        <div class="billing_plan_container"></div>
      </div>

      <additional-charges-modal></additional-charges-modal>
      `;


    this.renderMenu()
    this.querySelector('#signup_plan_select').onchange = (e) => {this.showRateSchedule(e.target.value)}
    this.showRateSchedule(this.rate_schedule_id)
  }  // connectedCallback

  // renders the options for the select menu
  renderMenu() {
    const menuEl = this.querySelector('#signup_plan_select')
    if (menuEl) {
      const currentRateScheduleId = this.rate_schedule_id
      this.data.map(rate_schedule => {
        // console.log('rate schedule data: ',rate_schedule)
        const rs = new RateScheduleCard(rate_schedule)
        const option = document.createElement('option')
        option.setAttribute('value', rate_schedule.id)

        if (currentRateScheduleId === rate_schedule.id){
          option.setAttribute('selected', true)
        }

        option.innerText = `${rate_schedule.rate_schedule_name} ${rs.get_base_price()}/month`
        menuEl.append(option)
      })
    }
  }
  
  // renders the selected rate schedule 
  showRateSchedule(rate_schedule_id) {
    rate_schedule_id = parseInt(rate_schedule_id)
    // console.log('new rate schedule id: ', rate_schedule_id)
    const billing_plan_container = this.querySelector('.billing_plan_container');
    billing_plan_container.innerHTML = ''

    if (this.data.length > 0) {
      this.data.map(rate_schedule => {
        if (rate_schedule_id === rate_schedule.id){
          billing_plan_container.appendChild(new SignupSummaryRateScheduleCard(rate_schedule))
        }        
      })
    }    
    this.rate_schedule_id = rate_schedule_id
  }
}
customElements.define("signup-summary-rate-schedule-cards", SignupSummaryRateSchedules)


class SignupSummaryRateScheduleCard extends RateScheduleCard{
  constructor(rate_schedule) {
    super(rate_schedule);
  }
 
  generate_additional_fees() {
    return `
      <a 
        title="Click to view the additional details"
        class="additional_fees">
        <span class="fa fa-plus"></span>
        Additional Details 
      </a>    
    `
  }

  connectedCallback() {
    this.populate_inner_html_template()
    this.innerHTML += `
      <h4 class="plan_fee_header">Monthy plan fee</h4>
      <h4 class="pull-right plan_fee_header">
        <span id="signup_plan_fee">
          ${this.get_base_price()}/month
        </span>
      </h4>    
    `
    // listener to show the additional charges modal
    this.querySelector(".additional_fees").addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation(); // needed to prevent clicks on the lower elements like pricing-card 
      const template = this.querySelector('#modal_template');
      const node = template.content.cloneNode(true)
      document.querySelector("additional-charges-modal").show(this.rateSchedule.data.rate_schedule_name, node)
    }.bind(this));
  }
}
customElements.define("signup-summary-rate-schedule-card", SignupSummaryRateScheduleCard)
